import React from "react";

interface propsTypes {
  children?: React.ReactNode;
  className?: string;
}

const H1 = (props: propsTypes) => {
  const { children } = props;
  return <h1 {...props}>{children}</h1>;
};
export default H1;
